// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"164":"856fc8f1","445":"0e214931","575":"0e214931"}[chunkId] + ".chunk.css";
};